import React from 'react';
import Helmet from 'react-helmet';

const TitleComponent = ({ title }) => {
  const defaultTitle = 'Default title app!';
  return (
    <Helmet>
      <title>{title || defaultTitle}</title>
    </Helmet>
  );
};

export default TitleComponent;
